/*
 * Компонент достался от прежней версии сайта и не описывает propTypes.
 * Здесь добавлены только блоки ThemeTexts и ThemeWidgets; переписывать типы всего
 * компонента заодно — отдельная задача, а не побочный эффект правки.
 */
/* eslint-disable react/prop-types, react/jsx-no-bind, css-modules/no-unused-class */
import React from 'react';
import { Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';
import withStyles from 'isomorphic-style-loader/withStyles';
import short from 'short-uuid';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import ThemeScreenshotSlider from './ThemeScreenshotSlider';
import SocialButtons from '../../components/Common/SocialButtons/SocialButtons';
import Badge from '../../components/Common/Badge/Badge';
import s from './Theme.css';
import Link from '../../components/Link';
import nl2br from '../../utils/nl2br';
import getUser, { isAdmin } from '../../utils/getUser';
import InstallDialog from './install/InstallDialog';
import MoreThemes from './more/MoreThemes';
import ThemeTexts from './ThemeTexts';
import ThemeWidgets from './ThemeWidgets';
import { reScreenshot } from '../../data/fetch/reScreenshot';

const shortUUID = short();

/**
 * Страничка одной темы
 */
class Theme extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			openInstallDialog: false,
			loadingReScreenshot: false,
		};
	}

	onCloseInstall() {
		this.setState({ openInstallDialog: false });
	}

	onInstallClick() {
		this.setState({ openInstallDialog: true });
	}

	async onScreenshotClick() {
		this.setState({ loadingReScreenshot: true });
		await reScreenshot(this.props.theme.id);
		this.setState({ loadingReScreenshot: false });
		document.location.reload();
	}

	render() {
		const user = getUser();
		const { theme, slug, workspaces, appJSON } = this.props;
		const amIAuthor = user && user.id === theme.author;
		const admin = isAdmin(user);

		return (
			<div>
				<div className={s.root}>
					<Container maxWidth="md">
						<Grid container>
							<Grid item xs={8}>
								<h2>
									{theme.title ? theme.title : 'No title'}

									<span
										style={{
											marginLeft: 10,
											fontSize: 15,
											verticalAlign: 6,
										}}
									>
										<Badge variant="primary">
											{theme.status}
										</Badge>
									</span>
								</h2>
							</Grid>

							<Grid item xs={4} className={s.ctaContainer}>
								<span title="Installs">
									{theme.installs} <GetAppIcon />
								</span>

								{admin && !this.state.loadingReScreenshot && (
									<Button
										variant="contained"
										color="primary"
										size="small"
										onClick={this.onScreenshotClick.bind(
											this,
										)}
									>
										Re-screenshot
									</Button>
								)}

								{this.state.loadingReScreenshot && (
									<CircularProgress size={20} />
								)}

								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={this.onInstallClick.bind(this)}
								>
									Install in a New Tab
								</Button>

								<Button
									variant="contained"
									color="secondary"
									size="small"
									onClick={() => {
										window.open(
											`/demo/xdr${theme.id}`,
											'_blank',
										);
									}}
								>
									Demo
								</Button>
							</Grid>
						</Grid>

						<Box component="div" style={{ textAlign: 'right' }}>
							{amIAuthor && (
								<Link to={`/theme/edit/${theme.id}`}>
									<Button
										startIcon={<EditIcon />}
										style={{ float: 'right' }}
										variant="contained"
										color="primary"
									>
										Edit
									</Button>
								</Link>
							)}
						</Box>

						<ThemeScreenshotSlider
							slug={slug}
							workspaces={workspaces}
							defaultIndex={appJSON.workspace}
						/>

						{admin && theme.author && (
							<Link to={`/themes/by/${theme.author}`}>
								More by Author
							</Link>
						)}

						{admin && !theme.author && 'No author'}

						<p className="read" style={{ marginBottom: 20 }}>
							{nl2br(theme.description)}
						</p>

						<SocialButtons />

						{this.state.openInstallDialog && (
							<InstallDialog
								onClose={this.onCloseInstall.bind(this)}
								code={shortUUID.fromUUID(theme.id)}
							/>
						)}
					</Container>
				</div>

				<ThemeTexts appJSON={appJSON} />

				<ThemeWidgets appJSON={appJSON} title={theme.title} />

				<MoreThemes moreThemes={this.props.moreThemes} />
			</div>
		);
	}
}

export default withStyles(s)(Theme);
